import { combineReducers } from 'redux';

const initialCurrencyState = { currency: 'MXN', isButton: false };

const currencyReducer = (state = initialCurrencyState, action) => {
  switch (action.type) {
    case 'SET_CURRENCY':
      return action.payload;
    case 'CLEAR_CURRENCY':
      return initialCurrencyState;
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  currency: currencyReducer,
});

export default rootReducer;
